import { FC } from 'react';
import { Tooltip } from 'react-tooltip';
import cn from 'classnames';

import styles from './styles.module.scss';
import SearchBarInput from './SearchBarInput';

import type { ISearchBoxTooltip } from '../config/declarations';

/* Main Component */
const SearchTooltip: FC<ISearchBoxTooltip> = ({
  tooltipRef,
  searchRef,
  searchValue,
  searchBox,
  psychicsList,
  search,
  clear,
  changeHandler,
  image,
}) => (
  <Tooltip
    ref={tooltipRef}
    delayShow={100}
    delayHide={100}
    noArrow
    openOnClick
    clickable
    closeEvents={{ blur: false, mouseleave: false }}
    className={cn(
      styles.tooltip,
      { [styles.tooltipPadding]: Boolean(searchValue) },
    )}
    place="bottom-start"
  >
    <SearchBarInput
      tooltipRef={tooltipRef}
      searchRef={searchRef}
      searchValue={searchValue}
      searchBox={searchBox}
      search={search}
      changeHandler={changeHandler}
      clear={clear}
      psychicsList={psychicsList}
      image={image}
      isTooltip
    />
  </Tooltip>
);

export default SearchTooltip;
